/**
 * Traceway (RUM): exceções, web vitals e session replay do lado do navegador.
 * Sem NUXT_PUBLIC_TRACEWAY_URL/TOKEN, o plugin não é registrado — mesmo padrão
 * de umami.client.ts (feature opcional, desligada se não configurada).
 */
import { createTracewayPlugin } from '@tracewayapp/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const url = String(config.public.tracewayUrl || '').replace(/\/$/, '')
  const token = String(config.public.tracewayToken || '')

  if (!url || !token) return

  nuxtApp.vueApp.use(createTracewayPlugin({
    connectionString: `${token}@${url}/api/report`,
  }))
})
